//#region BankModule

//#region BankAccount
class BankAccount {
    static readonly _ = 'Pages.App.Bank.BankAccount';
    static readonly Edit = 'Pages.App.Bank.BankAccount.Edit';
    static readonly Read = 'Pages.App.Bank.BankAccount.Read';
    static readonly BankAccountOverview = 'Pages.App.Bank.BankAccount.BankAccountOverview';
    static readonly Balance = 'Pages.App.Bank.BankAccount.Balance';
    static readonly RC = 'Pages.App.Bank.BankAccount.RC';
}

//#endregion BankAccount


//#region OutgoingBankTransactions
class OutgoingBankTransactions {
    static readonly _ = 'Pages.App.Bank.OutgoingBankTransactions';
    static readonly Create = 'Pages.App.Bank.OutgoingBankTransactions.Create';
    static readonly Edit = 'Pages.App.Bank.OutgoingBankTransactions.Edit';
    static readonly Delete = 'Pages.App.Bank.OutgoingBankTransactions.Delete';
}

//#endregion OutgoingBankTransactions

class BankModule {
    static readonly _ = 'Pages.App.Bank';
    //Dashboard is a child permission of BankModule
    static readonly Dashboard = 'Pages.App.Bank.Dashboard';
    //Accounting is a child permission of BankModule
    static readonly Accounting = 'Pages.App.Bank.Accounting';

    static get BankAccount(): typeof BankAccount {
        return BankAccount;
    }

    static get OutgoingBankTransactions(): typeof OutgoingBankTransactions {
        return OutgoingBankTransactions;
    }
}

//#endregion BankModule


//#region BookingModule

//#region BookingPeriods
class BookingPeriods {
    static readonly _ = 'Pages.App.Booking.BookingPeriods';
    static readonly Create = 'Pages.App.Booking.BookingPeriods.Create';
    static readonly Edit = 'Pages.App.Booking.BookingPeriods.Edit';
    static readonly Delete = 'Pages.App.Booking.BookingPeriods.Delete';

}

//#endregion BookingPeriods


//#region BookingPeriodsMapping
class BookingPeriodsMapping {
    static readonly _ = 'Pages.App.Booking.BookingPeriodsMapping';
    static readonly Create = 'Pages.App.Booking.BookingPeriodsMapping.Create';
    static readonly Edit = 'Pages.App.Booking.BookingPeriodsMapping.Edit';
    static readonly Delete = 'Pages.App.Booking.BookingPeriodsMapping.Delete';
}

//#endregion BookingPeriodsMapping


//#region AdditionalComments
class AdditionalComments {
    static readonly _ = 'Pages.App.Booking.AdditionalComments';
    static readonly Create = 'Pages.App.Booking.AdditionalComments.Create';
    static readonly Edit = 'Pages.App.Booking.AdditionalComments.Edit';
    static readonly Delete = 'Pages.App.Booking.AdditionalComments.Delete';
}

//#endregion AdditionalComments

//#region AccountingSettings
class AccountingSettings {
    static readonly _ = 'Pages.App.Booking.AccountingSettings';
    static readonly Edit = 'Pages.App.Booking.AccountingSettings.Edit';
}

//#endregion AccountingSettings


class BookingModule {
    //root BookingModule permission
    static readonly _ = 'Pages.App.Booking';
    //Bookings is a child permission of BankModule
    static readonly Bookings = 'Pages.App.Booking.Bookings';
    //Invoices is a child permission of BankModule
    static readonly Invoices = 'Pages.App.Booking.Invoices';
    //Assignments is a child permission of BankModule
    static readonly Assignments = 'Pages.App.Booking.Assignments';
    //Customers is a child permission of BankModule
    static readonly Customers = 'Pages.App.Booking.Customers';

    static get BookingPeriods(): typeof BookingPeriods {
        return BookingPeriods;
    }

    static get BookingPeriodsMapping(): typeof BookingPeriodsMapping {
        return BookingPeriodsMapping;
    }

    static get AdditionalComments(): typeof AdditionalComments {
        return AdditionalComments;
    }

    static get AccountingSettings(): typeof AccountingSettings {
        return AccountingSettings;
    }
}

//#endregion BookingModule


//#region Tax Module

class Tax {
    static readonly _ = 'Pages.App.Tax';

    static get Vehicles(): typeof Vehicles {
        return Vehicles;
    }
}

//#region Vehicles
class Vehicles {
    static readonly _ = 'Pages.App.Tax.Vehicles';
    static readonly Create = 'Pages.App.Tax.Vehicles.Create';
    static readonly Edit = 'Pages.App.Tax.Vehicles.Edit';
    static readonly Delete = 'Pages.App.Tax.Vehicles.Delete';
}

//#endregion Vehicles

//#endregion Tax

//#region ImportBank
class ImportBank {
    static readonly _ = 'Pages.App.ImportBank';
    static readonly Export = 'Pages.App.ImportBank.Export';
    static readonly Import = 'Pages.App.ImportBank.Import';
}

//#endregion Vehicles


class OrderGuide {
    static readonly _ = 'Pages.App.Webshop.OrderGuide';
    static readonly Create = 'Pages.App.Webshop.OrderGuide.Create';
    static readonly Edit = 'Pages.App.Webshop.OrderGuide.Edit';
    static readonly Delete = 'Pages.App.Webshop.OrderGuide.Delete';
    static readonly View = 'Pages.App.Webshop.OrderGuide.View';
    static readonly ReadOnlyAccess = 'Pages.App.Webshop.OrderGuide.ReadOnlyAccess';
    //Single order guide with template
    static readonly SingleOrderGuideWithTemplate = 'Pages.App.Webshop.OrderGuide.SingleOrderGuideWithTemplate';
    static readonly ViewTemplate = 'Pages.App.Webshop.OrderGuide.ViewTemplate';
}

class OrderManagement {
    static readonly _ = 'Pages.App.Webshop.OrderManagement';
    static readonly UpdateReference = 'Pages.App.Webshop.OrderManagement.UpdateReference';
    static readonly GetOrderByReference = 'Pages.App.Webshop.OrderManagement.GetOrderByReference';
}

class Banner {
    static readonly _ = 'Pages.App.Webshop.Configuration.Banner';
}

class Configuration {
    static readonly _ = 'Pages.App.Webshop.Configuration';

    static get Banner(): typeof Banner {
        return Banner;
    }
}


class Customer {
    static readonly _ = 'Pages.App.Webshop.Customer';
    static readonly CustomerOverview = 'Pages.App.Webshop.Customer.CustomerOverview';
    //Edit natural person
    static readonly CustomerEdit = 'Pages.App.Webshop.Customer.Edit';
    //Add natural person
    static readonly CustomerAdd = 'Pages.App.Webshop.Customer.Add';
    //Add natural person to a debitor
    static readonly CustomerAssign = 'Pages.App.Webshop.Customer.Assign';
    //This permission to determine if some one can override permentaly for the order
    static readonly ChangeDirectly = 'Pages.App.Webshop.Customer.ChangeDirectly';
}

class View {
    static readonly _ = 'Pages.App.Webshop.View';
    static readonly HasMOV = 'Pages.App.Webshop.View.HasMOV';
    static readonly ShowAvailableStockInfo = 'Pages.App.Webshop.View.ShowAvailableStockInfo';
    static readonly HighlightStockInformation = 'Pages.App.Webshop.View.HighlightStockInformation';
    static readonly ShowPalletsInfo = 'Pages.App.Webshop.View.ShowPalletsInfo';
    static readonly ShowBanner = 'Pages.App.Webshop.View.ShowBanner';
    //Guided requires for impersonation session
    static readonly Guided = 'Pages.App.Webshop.View.Guided';
    static readonly TableView = 'Pages.App.Webshop.View.TableView';
    static readonly ShowFavoriteArticles = 'Pages.App.Webshop.View.ShowFavoriteArticles';
}

class WMS {
    static readonly _ = 'Pages.App.Webshop.WMS';
    static readonly EditLocalStock = 'Pages.App.Webshop.WMS.EditLocalStock';
    static readonly ViewLocalStock = 'Pages.App.Webshop.WMS.ViewLocalStock';
}


class Webshop {
    static readonly _ = 'Pages.App.Webshop';

    static get OrderGuide(): typeof OrderGuide {
        return OrderGuide;
    }

    static get OrderManagement(): typeof OrderManagement {
        return OrderManagement;
    }

    static get Configuration(): typeof Configuration {
        return Configuration;
    }

    static get Customer(): typeof Customer {
        return Customer;
    }

    static get View(): typeof View {
        return View;
    }

    static get WMS(): typeof WMS {
        return WMS;
    }
}

//#region User
class UserCreation {
    static readonly _ = 'Pages.Environment.Administration.Users.Creation';
    static readonly ManageAccount = 'Pages.Environment.Administration.Users.Creation.ManageAccount';
    static readonly ManageSecurity = 'Pages.Environment.Administration.Users.Creation.ManageSecurity';
}

class ProfileManagement {
    static readonly _ = 'Pages.Environment.Administration.Users.ProfileManagement';
    static readonly Delivery = 'Pages.Environment.Administration.Users.ProfileManagement.Delivery';
    static readonly Financial = 'Pages.Environment.Administration.Users.ProfileManagement.Financial';
    static readonly Invoice = 'Pages.Environment.Administration.Users.ProfileManagement.Invoice';
    static readonly Visitor = 'Pages.Environment.Administration.Users.ProfileManagement.Visitor';
}
class UserManagement {
    static readonly _ = 'Pages.Environment.Administration.Users.UserManagement';
    static readonly Delivery = 'Pages.Environment.Administration.Users.UserManagement.Delivery';
    static readonly Financial = 'Pages.Environment.Administration.Users.UserManagement.Financial';
    static readonly Invoice = 'Pages.Environment.Administration.Users.UserManagement.Invoice';
    static readonly Visitor = 'Pages.Environment.Administration.Users.UserManagement.Visitor';
}

class User {
    static readonly _ = 'Pages.Environment.Administration.Users';
    static readonly UsersCreate = 'Pages.Environment.Administration.Users.Create';
    static readonly UsersEdit = 'Pages.Environment.Administration.Users.Edit';
    static readonly UsersEditSyncUsers = 'Pages.Environment.Administration.Users.EditSyncUser';
    static readonly UsersDelete = 'Pages.Environment.Administration.Users.Delete';
    static readonly UsersChangePermission = 'Pages.Environment.Administration.Users.ChangePermission';
    static readonly UsersImpersonation = 'Pages.Environment.Administration.Users.Impersonation';
    static readonly UsersUnlock = 'Pages.Environment.Administration.Users.Unlock';
    static readonly UsersMaintenance = 'Pages.Environment.Administration.Users.Maintenance';
    static readonly UsersHangfireDashboard = 'Pages.Environment.Administration.Users.HangfireDashboard';
    static readonly UsersHostDashboard = 'Pages.Environment.Administration.Users.Host_Dashboard';
    static readonly UsersHostSettings = 'Pages.Environment.Administration.Users.Host_Settings';
    static readonly UsersSelfRegistration = 'Pages.Environment.Administration.Users.SelfRegistration';

    static get UserCreation(): typeof UserCreation {
        return UserCreation;
    }

    static get ProfileManagement(): typeof ProfileManagement {
        return ProfileManagement;
    }
    static get UserManagement(): typeof UserManagement {
        return UserManagement;
    }
}



//#endregion User

//#region Role
export class Role {
    static readonly _ = 'Pages.Environment.Administration.Roles';
    static readonly RolesCreate = 'Pages.Environment.Administration.Roles.Create';
    static readonly RolesEdit = 'Pages.Environment.Administration.Roles.Edit';
    static readonly RolesDelete = 'Pages.Environment.Administration.Roles.Delete';
}
//#endregion Role

//#region OrganizationUnit
export class OrganizationUnit {
    static readonly _ = 'Pages.Environment.Administration.OrganizationUnits';
    static readonly ManageOrganizationTree = 'Pages.Environment.Administration.OrganizationUnits.ManageOrganizationTree';
    static readonly ManageMembers = 'Pages.Environment.Administration.OrganizationUnits.ManageMembers';
    static readonly ManageRoles = 'Pages.Environment.Administration.OrganizationUnits.ManageRoles';

}
//#endregion OrganizationUnit

export class BasePermissionDefinition {
    static administrationEditions = 'Pages.Administration.Editions';
    static administrationEditionsCreate = 'Pages.Administration.Editions.Create';
    static administrationEditionsEdit = 'Pages.Administration.Editions.Edit';
    static administrationEditionsDelete = 'Pages.Administration.Editions.Delete';
    static administrationEditionsMoveTenantsToAnotherEdition = 'Pages.Administration.Editions.MoveTenantsToAnotherEdition';
    static administrationEditionsAvailability = 'Pages.Administration.Editions.Availability';
    static administrationEditionsPrivateFeature = 'Pages.Administration.Editions.PrivateFeature';
    static administrationLanguages = 'Pages.Administration.Language';
    static administrationLanguagesCreate = 'Pages.Administration.Language.Create';
    static administrationLanguagesEdit = 'Pages.Administration.Language.Edit';
    static administrationLanguagesDelete = 'Pages.Administration.Language.Delete';
    static administrationLanguagesChangeTexts = 'Pages.Administration.Languages.ChangeTexts';
    static administrationHangfireDashboard = 'Pages.Administration.HangfireDashboard';
    static baseTenantUserPermissionRoles = 'Pages.Environment.Administration.Roles';
    static baseTenantUserPermissionRolesCreate = 'Pages.Environment.Administration.Roles.Create';
    static baseTenantUserPermissionRolesEdit = 'Pages.Environment.Administration.Roles.Edit';
    static baseTenantUserPermissionRolesDelete = 'Pages.Environment.Administration.Roles.Delete';
    static baseTenantUserPermissionUsers = 'Pages.Environment.Administration.Users';
    static baseTenantUserPermissionUsersCreate = 'Pages.Environment.Administration.Users.Create';
    static baseTenantUserPermissionUsersEdit = 'Pages.Environment.Administration.Users.Edit';
    static baseTenantUserPermissionUsersEditSyncUsers = 'Pages.Environment.Administration.Users.EditSyncUser';
    static baseTenantUserPermissionUsersDelete = 'Pages.Environment.Administration.Users.Delete';
    static baseTenantUserPermissionUsersChangePermission = 'Pages.Environment.Administration.Users.ChangePermission';
    static baseTenantUserPermissionUsersImpersonation = 'Pages.Environment.Administration.Users.Impersonation';
    static baseTenantUserPermissionUsersUnlock = 'Pages.Environment.Administration.Users.Unlock';
    static baseTenantUserPermissionUsersMaintenance = 'Pages.Environment.Administration.Users.Maintenance';
    static baseTenantUserPermissionUsersHangfireDashboard = 'Pages.Environment.Administration.Users.HangfireDashboard';
    static baseTenantUserPermissionUsersHostDashboard = 'Pages.Environment.Administration.Users.Host_Dashboard';
    static baseTenantUserPermissionUsersHostSettings = 'Pages.Environment.Administration.Users.Host_Settings';
    static baseTenantUserPermissionUsersSelfRegistration = 'Pages.Environment.Administration.Users.SelfRegistration';
    static baseTenantUserPermissionTenantsHostMaintenants = 'Pages.Environment.Administration.Tenants.HostMaintenance';
    static baseTenantUserPermissionTenants = 'Pages.Environment.Administration.Tenants';
    static baseTenantUserPermissionTenantsCreate = 'Pages.Environment.Administration.Tenants.Create';
    static baseTenantUserPermissionTenantsEdit = 'Pages.Environment.Administration.Tenants.Edit';
    static baseTenantUserPermissionTenantsSettings = 'Pages.Environment.Administration.Tenants.Settings';
    static baseTenantUserPermissionTenantsDelete = 'Pages.Environment.Administration.Tenants.Delete';
    static baseTenantUserPermissionTenantsChangeFeatures = 'Pages.Environment.Administration.Tenants.ChangeFeatures';
    static baseTenantUserPermissionTenantsImpersonation = 'Pages.Environment.Administration.Tenants.Impersonation';
    static baseTenantUserPermissionTenantsSelfRegistration = 'Pages.Environment.Administration.Tenants.SelfRegistration';
    static baseTenantUserPermissionTenantsBranding = 'Pages.Environment.Administration.Tenants.Branding';
    static baseTenantUserPermissionTenantsChangeSubscription = 'Pages.Environment.Administration.Tenants.ChangeSubscription';
    static baseTenantUserPermissionOrganizationUnits = 'Pages.Environment.Administration.OrganizationUnits';
    static baseTenantUserPermissionOrganizationUnitsManageOrganizationTree = 'Pages.Environment.Administration.OrganizationUnits.ManageOrganizationTree';
    static baseTenantUserPermissionOrganizationUnitsManageMembers = 'Pages.Environment.Administration.OrganizationUnits.ManageMembers';
    static baseTenantUserPermissionOrganizationUnitsManageRoles = 'Pages.Environment.Administration.OrganizationUnits.ManageRoles';
    static appManageApp = 'Pages.App.ManageApp';
    static appManageAppApp = 'Pages.App.ManageApp.App';
    static appManageAppAppViewApp = 'Pages.App.ManageApp.App.View';
    static appManageAppAppEditApp = 'Pages.App.ManageApp.App.Edit';
    static appManageAppAppDeleteApp = 'Pages.App.ManageApp.App.Delete';
    static appManageAppAppApiCall = 'Pages.App.ManageApp.App.ApiCall';
    static appManageAppAppApiCallViewApiCall = 'Pages.App.ManageApp.App.ApiCall.View';
    static appManageAppAppApiCallEditApiCall = 'Pages.App.ManageApp.App.ApiCall.Edit';
    static appManageAppAppApiCallCreateApiCall = 'Pages.App.ManageApp.App.ApiCall.Create';
    static appManageAppAppProcessorExecution = 'Pages.App.ManageApp.App.ProcessorExecution';
    static appManageAppAppProcessorExecutionView = 'Pages.App.ManageApp.App.ProcessorExecution.View';
    static appManageAppAppProcessorExecutionEdit = 'Pages.App.ManageApp.App.ProcessorExecution.Edit';
    static appManageAppAppProcessorExecutionCreate = 'Pages.App.ManageApp.App.ProcessorExecution.Create';
    static appManageAppAppProcessorExecutionDelete = 'Pages.App.ManageApp.App.ProcessorExecution.Delete';
    static appManageAppAppManageSettings = 'Pages.App.ManageApp.App.ManageSettings';
    static appManageAppAppManageSettingsView = 'Pages.App.ManageApp.App.ManageSettings.View';
    static appManageAppAppManageSettingsEdit = 'Pages.App.ManageApp.App.ManageSettings.Edit';
    static appCustomLinks = 'Pages.App.CustomLinks';
    static appCustomLinksCreate = 'Pages.App.CustomLinks.Create';
    static appCustomLinksEdit = 'Pages.App.CustomLinks.Edit';
    static appCustomLinksDelete = 'Pages.App.CustomLinks.Delete';
    static appCustomLinksView = 'Pages.App.CustomLinks.View';
    static appInvoicePaymentTerms = 'Pages.App.Invoice.PaymentTerms';
    static appInvoicePaymentTermsCreate = 'Pages.App.Invoice.PaymentTerms.Create';
    static appInvoicePaymentTermsEdit = 'Pages.App.Invoice.PaymentTerms.Edit';
    static appInvoicePaymentTermsDelete = 'Pages.App.Invoice.PaymentTerms.Delete';
    static taxGla = 'Pages.App.Tax.GLA';
    static taxGlaCreate = 'Pages.App.Tax.GLA.Create';
    static taxGlaEdit = 'Pages.App.Tax.GLA.Edit';
    static taxGlaDelete = 'Pages.App.Tax.GLA.Delete';

    static get BookingModule(): typeof BookingModule {
        return BookingModule;
    }

    static get BankModule(): typeof BankModule {
        return BankModule;
    }

    static get Tax(): typeof Tax {
        return Tax;
    }

    static get ImportBank(): typeof ImportBank {
        return ImportBank;
    }

    static get Webshop(): typeof Webshop {
        return Webshop;
    }

    static get User(): typeof User {
        return User;
    }

    static get Role(): typeof Role {
        return Role;
    }
    static get OrganizationUnit(): typeof OrganizationUnit {
        return OrganizationUnit;
    }
}
